import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import gmail from "../../images/gmail.png";
import requestStatus from "../../images/requestStatus.png";
import location from "../../images/location.png";
import credit from "../../images/credit.png";
import document from "../../images/document.png";
import phone from "../../images/phone.png";
import bank from "../../images/bank.png";
import mode from "../../images/AutorenewOutlined.png";
import channel from "../../images/SettingsOutlined.png";
import changePaymentChannel from "../../images/changePaymentChannel.png";
import changePayMode from "../../images/changePayMode.png";
import Header_Home from "../Component/Header_Home";
import { useNavigate } from "react-router-dom";
import "./personal.css";
import { getPersonalMenu } from "./PersonalService/personalService";
import CryptoJS from 'crypto-js';
import { getPolicyInformationAPI } from "../PolicyList/PolicyListService/policyListService";
import {
  insertActivityLog,
} from "../Home/homeService/homeService";
const Personal = () => {
  let navigate = useNavigate();
  const [menuList, setMenuList] = useState([]);
  const [dataPolicies, setDataPolicies] = useState([]);
  const insureIdCard = localStorage.getItem("customer_id") || "";
  const handleRoute = (obj) => {
    handleSubmitLog(obj.variable1)
    if (obj.code === "MST012_8" || (obj.variable3 && obj.variable3.includes("ChangeChannelPay"))) {
      navigate(obj.variable3, { state: { dataPolicies } });
    } else {
      navigate(obj.variable3, { state: { dataPolicies } });
    }
  };

  useEffect(() => {
    initialPersonalMenu();
    getPolicyInformation()
  }, []);

  const initialPersonalMenu = async () => {
    const res = await getPersonalMenu();
    setMenuList(res.data);
  };

  const img = (req) => {
    switch (req) {
      case "MST012_1":
        return location;
      case "MST012_2":
        return phone;
      case "MST012_3":
        return gmail;
      case "MST012_4":
        return document;
      case "MST012_5":
        return credit;
      case "MST012_6":
        return bank;
      case "MST012_7":
        return changePayMode;
      case "MST012_8":
        return changePaymentChannel;
      default:
        return requestStatus;
    }
  };

   const handleSubmitLog = async (type) => {
      const citizen = localStorage.getItem("customer_id");

      if (!citizen) {
        console.error("No encrypted citizen ID found in localStorage.");
        return;
      }

      const decrypted = decryptCardNumber(citizen, process.env.REACT_APP_ENCRYPT_DATA); // ตรวจสอบว่า secretKey ถูกต้องหรือไม่
      const activityMap = {
        citizenID: decrypted,
        activityType: type
      };
      await insertActivityLog(activityMap);


    };

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getPolicyInformation = async () => {
    const result = await getPolicyInformationAPI(
        decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA)
    );
    if (result.status) {
      setDataPolicies(result.data.policies);
    }
  };

  return (
    <>
      <Header_Home />

      <div className="item-container">
        <div className="row">
          <div className="col-12">
            <h5>
              <b>แจ้งเปลี่ยนแปลง</b>
            </h5>
          </div>
          {menuList &&
            // menuList.length &&
            menuList.map(
              (post, index) => (
                <div key={index} className="col-4 mar">
                  <a onClick={() => handleRoute(post)}>
                    <div className="item-menu flex-column text-center">
                      <img
                        className="image align-self-center mt-2"
                        src={img(post.code)}
                        alt="icon"
                      />
                      <p className="flex-shrink-1" style={{ color: " #F2654E" }}>{post.variable1}</p>
                    </div>
                  </a>
                </div>
              )
            )}
        </div>
      </div>

    </>
  );
};

export default Personal;
